require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-react-set-state-with-this-setstate.json") })
        }
      }, "path---front-end-libraries-react-set-state-with-this-setstate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-react-set-state-with-this-setstate!./.cache/json/front-end-libraries-react-set-state-with-this-setstate.json
// module id = 2088
// module chunks = 231608221292675